import React from "react";
import style from './SvgLoader.module.css'
const SvgLoader = (props) => {
  return (
    <div className={props.isLoader ? style.heartbeatloader : style.heartbeatloader1} >
      <svg className="svgdraw" width="100%" height="100%" viewBox="0 0 150 400">
        <path
          className={style.path}
          d="M 0 200 l 40 0 l 5 -40 l 5 40 l 10 0 l 5 15 l 10 -140 l 10 220 l 5 -95 l 10 0 l 5 20 l 5 -20 l 30 0"
          fill="transparent"
          strokeWidth="4"
          stroke="#fff"
        />
      </svg>

      <div className={style.innercircle}></div>
      <div className={style.outercircle}></div>
    </div>
  );
};

export default SvgLoader;
